// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","174":"247d17c5","214":"b39a97d6","250":"0f1d58a7","458":"8be8bad3","577":"66801e42","652":"0643e35d","660":"9d7e1307","682":"d5252985","783":"c66ca607","812":"595909e7","846":"bac1f359","867":"f52cf73e","904":"0c67cfd9","985":"de897744"}[chunkId] + ".js";
};